import { useContext } from 'react';
import AuthContext from '../contexts/authContext';
import AccessContext from '../contexts/accessContext';

export const Protected = ({ action, children }) => {
	const { access } = useContext(AccessContext);
	const { userData } = useContext(AuthContext);
	if (userData?.role === 'sup_admin') {
		return children;
	}
	return access?.includes?.(action) ? children : null;
};
